import automaisLogo from '../img/Automais_logo.png'
import maisLogoHd from '../img/mais_logo_hd.png'
import { useTheme } from '../contexts/ThemeContext'

/**
 * Logo principal da marca (substitui texto + ícone).
 * @param {string} className - classes Tailwind (ex.: h-10 w-auto max-w-[200px])
 * @param {string} alt
 */
export default function BrandLogo({
  className = 'h-[4em] w-auto max-w-[min(100%,360px)] object-contain object-center',
  alt = 'Automais',
  compact = false,
}) {
  const { customization } = useTheme()
  const logoBase64 = customization?.logoBase64 || customization?.LogoBase64
  const logoUrl = customization?.logoUrl || customization?.LogoUrl
  const src = logoBase64 || logoUrl || (compact ? maisLogoHd : automaisLogo)
  return <img src={src} alt={alt} className={className} />
}
